export default __webpack_public_path__ + "static/media/warning.f7d2618f.svg";